import React, { useState } from 'react'
import './index.less'

interface TabItem {
  key: string
  title: string
  subTitle?: string
  onClick: () => void
}

interface Props {
  firstShowTabKey?: string
  showUnderline?: boolean
  tabItems: TabItem[]
  className?: string
}

const App = React.memo(function TabsBar({ firstShowTabKey, showUnderline, tabItems, className }: Props) {
  const [hlTab, setHlTab] = useState(firstShowTabKey || tabItems[0]?.key || '')

  const clickTab = (tabItem: TabItem) => {
    setHlTab(tabItem?.key)
    tabItem?.onClick()
  }

  return (
    <div className={`tabs-bar ${className} ${tabItems.length === 2 ? 'two-tabs' : ''}`}>
      {
        tabItems?.length > 0 && tabItems.map((tabItem, index) => (
          <div className={`tab-pane`} key={index} onClick={() => clickTab(tabItem)}>
            <div className={`title ${tabItem.key === hlTab ? 'highlight' : ''}`}>{tabItem?.title}</div>
            { tabItem?.subTitle && <div className={`sub-title ${tabItem.key === hlTab ? 'highlight' : ''}`}>{tabItem?.subTitle}</div> }
            { !!showUnderline && tabItem.key === hlTab && <div className='underline'></div> }
          </div>
        ))
      }
    </div>
  )
})

export default App